// Setzt die im Markup zerlegten E-Mail-Adressen zusammen (Schutz vor Adress-Sammlern).
// Anker: <a class="rh-mail" data-p1="info" data-p2="reinh" data-p3="art"></a>
(function () {
  function bauen() {
    document.querySelectorAll('a.rh-mail').forEach(function (a) {
      if (a.dataset.rhFertig) return;
      var m = a.dataset.p1 + '@' + a.dataset.p2 + '.' + a.dataset.p3;
      a.href = 'mai' + 'lto:' + m;
      if (!a.textContent.trim()) {
        a.appendChild(document.createTextNode(m));
      } else if (!a.querySelector('.rh-mail-txt')) {
        var s = document.createElement('span');
        s.className = 'rh-mail-txt';
        s.textContent = m;
        a.appendChild(s);
      }
      a.dataset.rhFertig = '1';
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bauen);
  } else {
    bauen();
  }
})();
